/**
 * Слой углов (узлов графа стен). Ручки углов показываются только инструментом
 * выделения — за них тянут планировку, все примыкающие стены идут за углом.
 */
import type { PointerEvent } from "react";
import { NodeHandle, type PlanNode } from "../../plan";
import { SelectionKind, Tool, useEditorStore } from "@/widgets/editor";

interface Props {
	nodes: PlanNode[];
	mmPerPx: number;
	onNodePointerDown: (e: PointerEvent<Element>, node: PlanNode) => void;
}

export const NodesLayer2D = ({ nodes, mmPerPx, onNodePointerDown }: Props) => {
	const selection = useEditorStore((s) => s.selection);
	const tool = useEditorStore((s) => s.tool);
	if (tool !== Tool.Select) return null;
	return (
		<g>
			{nodes.map((node) => (
				<NodeHandle
					key={`node-${node.id}`}
					node={node}
					selected={selection?.kind === SelectionKind.Node && selection.id === node.id}
					mmPerPx={mmPerPx}
					onPointerDown={(e) => onNodePointerDown(e, node)}
				/>
			))}
		</g>
	);
};
